import { networkClient } from '@network/networkClient'
import { CRASH_ROUND_INFO, CRASH_PROVABLY_FAIR, CRASH_SEND_CLIENT_SEED } from '../queries/crashQueries'
import { logger } from '@logger'

const MODULE = 'Crash Service'

// Fairness info for a finished round.
export const fetchRoundInfo = async ({ roundId } = {}) => {
  const response = await networkClient({
    request: { query: CRASH_ROUND_INFO, variables: { roundId } },
  })

  logger.info(MODULE, 'fetchRoundInfo Response', response)

  if (response.crash.roundInfo.success) {
    return response.crash.roundInfo.data
  } else {
    throw new Error(response.crash.roundInfo.message || 'Failed to fetch round info')
  }
}

// Live provably-fair commitment + algorithm parameters.
export const fetchProvablyFair = async ({ gameCode, gameMode } = {}) => {
  const response = await networkClient({
    request: { query: CRASH_PROVABLY_FAIR, variables: { gameCode, gameMode } },
  })

  logger.info(MODULE, 'fetchProvablyFair Response', response)

  if (response.crash.provablyFair.success) {
    return response.crash.provablyFair.data
  } else {
    throw new Error(response.crash.provablyFair.message || 'Failed to fetch provably fair info')
  }
}

/**
 * Register the player's client seed for the round in play (provably fair v2).
 *
 * Resolves with the payload for BOTH an accepted and a rejected seed — rejection
 * ('someone else took the last slot', 'you already have one') is the common case,
 * not a failure, and the caller must not have to tell them apart. Only a transport
 * or auth failure rejects, and the caller's job there is to log and move on: the
 * round seals with a server fallback and stays fully verifiable.
 */
export const sendClientSeed = async ({ clientSeed, roundId } = {}) => {
  const response = await networkClient({
    request: {
      query: CRASH_SEND_CLIENT_SEED,
      variables: { input: { clientSeed, roundId } },
      isAuthRequired: true,
    },
  })

  const envelope = response?.crash?.sendClientSeed

  logger.info(MODULE, 'sendClientSeed Response', envelope)

  if (!envelope?.success) {
    throw new Error(envelope?.message || 'Failed to register the client seed')
  }

  return envelope.data
}
